export enum CashbackStatusEnum {
    PedidoCancelado = -1,
    PendenteLiberacao = 1,
    Disponivel = 2,
    PendenteResgate = 3,
    Resgatado = 4
}
